module.exports = __webpack_public_path__ + "img/primary_10x3_z18.832dc0ca.svg";